import React from "react"

import KnowledgeModerationButtons from "../../../common/knowledge-list/KnowledgeModerationButtons"
import ViewFormActionButtonsWidget from "../../../common/ViewFormActionButtonsWidget"

const ClusterViewFormActionButtonsWidget = props => {
    const {
        canEdit,
        moderationStatus,
        suggestedModerationStatus,
        approve,
        reject,
        unmoderate,
        isSaving
    } = props

    return (
        <ViewFormActionButtonsWidget {...props}>
            <KnowledgeModerationButtons
                {...{
                    canSave: canEdit,
                    isSaving,
                    moderationStatus,
                    approve,
                    reject,
                    unmoderate,
                    suggestedModerationStatus
                }}
            />
        </ViewFormActionButtonsWidget>
    )
}

export default ClusterViewFormActionButtonsWidget
